export enum PrescriptionGeneratorService {
  PRESCRYPTO = 'Prescrypto',
  MEMED = 'Memed'
}
